import { ClosureContext } from 'pages/Closures/ClosureClose';

export enum FormContextActionEnum {
  SWITCH_INVENTAIRE_PAR_SEPARATION = 'SWITCH_INVENTAIRE_PAR_SEPARATION',
  UPDATE_INVENTAIRE_PAR_SEPARATION_CHECKBOX = 'UPDATE_INVENTAIRE_PAR_SEPARATION_CHECKBOX',
}
export const setFormContextByAction = (
  action: FormContextActionEnum,
  value: boolean | InventaireParSeparationCheckboxUpdateValue,
  setFormContext: React.Dispatch<React.SetStateAction<ClosureContext | undefined>>,
) => {
  switch (action) {
    case FormContextActionEnum.SWITCH_INVENTAIRE_PAR_SEPARATION:
      if ('boolean' !== typeof value) {
        throw new Error(
          'Type of the value for ' +
            FormContextActionEnum.SWITCH_INVENTAIRE_PAR_SEPARATION +
            ' action must be of type boolean',
        );
      }

      if (value) {
        setFormContext(previousFormContext => ({
          ...previousFormContext,
          stepInventoriedInboundStock: {
            ...previousFormContext?.stepInventoriedInboundStock,
            isSwitchInventaireOn: value,
          },
        }));
      } else {
        setFormContext(previousFormContext => ({
          ...previousFormContext,
          stepInventoriedInboundStock: {
            inventaireParSeparationCheckboxes: {},
            isSwitchInventaireOn: value,
          },
        }));
      }
      break;
    case FormContextActionEnum.UPDATE_INVENTAIRE_PAR_SEPARATION_CHECKBOX:
      if (!(typeof value === 'object' && value !== null && 'index' in value && 'checked' in value)) {
        throw new Error(
          'Type of the value for ' +
            FormContextActionEnum.UPDATE_INVENTAIRE_PAR_SEPARATION_CHECKBOX +
            ' action must be of type {index: number, value: boolean}',
        );
      }

      setFormContext(previousFormContext => ({
        ...previousFormContext,
        stepInventoriedInboundStock: {
          ...previousFormContext?.stepInventoriedInboundStock,
          inventaireParSeparationCheckboxes: {
            ...previousFormContext?.stepInventoriedInboundStock?.inventaireParSeparationCheckboxes,
            [value.index]: value.checked,
          },
        },
      }));
      break;
  }
};

interface InventaireParSeparationCheckboxUpdateValue {
  index: number;
  checked: boolean;
}
